module.exports = __webpack_public_path__ + "static/media/space-gif1.7d52f227.gif";